import { BarChartUrl } from '@icons';
import { orderBy } from 'lodash-es';
import { BarChartWidget } from '@features/components/ClinicalData/components/BarChartWidget';
import { ClinicalHeader } from '@features/components/ClinicalBarChart';
import { getColorsByOrganType } from '@/utils/helpers';
import { ClinicalData, OrganType } from '@/api/apis/case';
import { formatBile, formatLactate } from './utils';

export const LactateData = ({ organType, clinicalData }: { organType: OrganType; clinicalData: ClinicalData }) => {
  const lactate = formatLactate(clinicalData, { excludeNullLactate: true });
  const bile = orderBy(formatBile(clinicalData), 'timestamp');
  const colors = getColorsByOrganType(organType);
  const latestLactate = lactate.at(-1);
  const latestBile = bile.at(-1);

  return (
    <BarChartWidget organType={organType} color={colors.bg40} header="Lactate" icon={BarChartUrl} values={lactate}>
      <ClinicalHeader
        currentValue={latestLactate?.value}
        prevValue={lactate.at(-2)?.value}
        diffLabel="mmol/L"
        measurementUnits="(mmol/L)"
        parameter="Lactate"
        ocsTime={latestLactate?.ocsTime}
        timeString={latestLactate?.time}
        bileValue={latestBile?.value}
      />
    </BarChartWidget>
  );
};
